import { useState } from 'react'
import { FluentSignOut24Filled, LetsIconsOrder, MynauiCartSolid } from '../../../assets/icons/Icons';
import CartModal from '../../modals/Guest/CartModal';
import OrderModal from '../../modals/Guest/OrderModal';
import InformationModal from '../../modals/InformationModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentGuestGenerateUsername, selectCurrentUserId } from '../../../features/auth/authSlice';
import capitalBrewLogo from "../../../assets/images/capital brew logo.png";
import { clearTypeOfShowModalType, selectCurrentShowTypeOfModal } from '../../../features/modal/modalSlice';
import { STATUS } from '../../../constant/constant';
import { useDynamicQueryData } from '../../../hooks/api/useDynamicQueryData';
import { useStoreTimer } from '../../../utils/useStoreTimer';
import useGuestAction from '../../../hooks/actions/useGuestAction';
import ConfirmationModal from '../../modals/ConfirmationModal';

export default function UserNavbar() {

    const { storeOpen  } = useStoreTimer();
    const guestId = useSelector(selectCurrentUserId)
    const generateUsername = useSelector(selectCurrentGuestGenerateUsername)
    const dispatch = useDispatch()
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const [isLogOutOpen, setIsLogOutOpen] = useState<boolean>(false);
    const { guestCart, myOrders, isLoadingMyOrders, } = useDynamicQueryData({guestId})
    const { handleCartModal, handleOrderModal, handleLogoutGuest } = useGuestAction()
    
    const ignoredStatuses = new Set([
        STATUS.forPickUp.name.toLowerCase(),
        STATUS.cancelled.name.toLowerCase(),
        STATUS.claimed.name.toLowerCase(),
    ]);
    const count = myOrders?.filter((order) => !ignoredStatuses.has(order.status.toLowerCase())).length;

    const cartItemCount = guestCart?.items?.length ?? 0;
    const hasCartItems = cartItemCount > 0;
    const isShowOrderModal = typeOfModalShow === 'viewOrder'
    const isShowCartModal = typeOfModalShow === 'viewCart'
    const shouldShowCartModal = storeOpen && isShowCartModal;
    const notificationCount = count ?? 0;
    const hasNotifications = notificationCount > 0;

    return (
        <div className='w-full flex justify-center items-center fixed bg-white shadow-md z-50'>
            <div className='container lg:px-8'>
                <div className="flex items-center justify-center gap-2 text-sm font-medium text-gray-800 px-4">
                    <span className="text-gray-500">Welcome,</span>
                    <span className="font-semibold capitalize text-cbColor">
                        {generateUsername}
                    </span>
                </div>
                <div className='flex justify-between items-center h-auto py-3 md:py-2 lg:container'>
                    <div className="flex items-center gap-3 cursor-pointer">
                        <img src={capitalBrewLogo}  alt="Admin Dashboard" className="h-8 lg:h-10 w-auto object-contain"/>
                    </div>
                    <div className='flex items-center gap-2 relative'>
                        <button
                            onClick={() => {if (storeOpen) handleCartModal()}}
                            disabled={!storeOpen}
                            className={`relative text-sm px-3 py-2 rounded-lg font-medium transition-all bg-cbColor text-white shadow-md ${!storeOpen ? 'cursor-not-allowed' : ''}`}
                        >
                            <MynauiCartSolid width={16} height={16} />
                            { hasCartItems && (
                                <span className='absolute -top-1 -right-1 bg-cbColor text-white text-[10px] font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-white'>
                                    {cartItemCount}
                                </span>
                            )}
                        </button>
                        {shouldShowCartModal && ( <CartModal isStoreOpen={storeOpen}/> )}
                        <button
                            onClick={handleOrderModal}
                            className={`relative text-sm px-3 py-2 rounded-lg font-medium transition-all bg-cbColor text-white shadow-md`}
                        >
                            <LetsIconsOrder width={16} height={16} />
                            {hasNotifications && (
                                <span className='absolute -top-1 -right-1 bg-cbColor text-white text-[10px] font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-white'>
                                    {isLoadingMyOrders ? '.' : count}
                                </span>
                            )}
                        </button>
                        { isShowOrderModal && (
                            <OrderModal/>
                        )}

                        <button
                            onClick={() => {
                                setIsLogOutOpen(!isLogOutOpen)
                                dispatch(clearTypeOfShowModalType());
                            }}
                            className="flex space-x-2 items-center text-black text-sm font-medium rounded-lg transition bg-cbColor px-3 py-2.5"
                        >
                            <span>
                                <FluentSignOut24Filled height={14} width={14} color='white'/>{" "}
                            </span>
                        </button>

                        {isLogOutOpen && (
                            <ConfirmationModal
                                onCancel={() => {
                                    setIsLogOutOpen(false)
                                }}
                                onConfirm={handleLogoutGuest}
                                isLoading={false}
                                modalTitle={`Logout`}
                                modalSubTitle={`Are you sure you want to logout?`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
